import { Component, Input } from "@angular/core";
import { SimpleModalComponent } from "ngx-simple-modal";

@Component({
  selector: "confirmation-modal",
  templateUrl: "./confirmation-modal.component.html",
  styleUrls: ["./confirmation-modal.component.scss"]
})
export class ConfirmationModalComponent
  extends SimpleModalComponent<ConfirmationModel, ConfirmationModalResult> {

  @Input() title: string;
  @Input() messageTranslationKey: string;
  @Input() confirmButtonTextTranslationKey = "CONFIRMATION_MODAL.OPTION_YES";
  @Input() cancelButtonTextTranslationKey = "CONFIRMATION_MODAL.OPTION_NO";
  @Input() executeIconClass = "";
  @Input() isActionDanger = true;
  @Input() showDontAskAgain = true;

  dontAskAgain = false;

  confirm() {
    this.result = { confirmed: true, dontAskAgain: this.dontAskAgain };
    this.close().then();
  }

  cancel() {
    this.result = { confirmed: false, dontAskAgain: false };
    this.close().then();
  }
}

interface ConfirmationModel {
  title: string;
  messageTranslationKey: string;
  confirmButtonTextTranslationKey?: string;
  cancelButtonTextTranslationKey?: string;
  executeIconClass?: string;
  showDontAskAgain?: boolean;
  isActionDanger?: boolean;
}

export interface ConfirmationModalResult {
  confirmed: boolean;
  dontAskAgain: boolean;
}
